const lockedApps = ['mtlab', 'clubmedcancun', 'zombiesMTL', 'lacmegantic', 'mtl', 'amp2018']
const lockedTokens = ['c']

const fbShareApps = ['jaune', 'rose', 'gris', 'turquoise']

export const appIsLocked = (appId) => lockedApps.indexOf(appId) >= 0
export const tokenIsLocked = (tokenId) => lockedTokens.indexOf(tokenId) >= 0
export const appIsFacebookShare = (appId) => fbShareApps.indexOf(appId) >= 0



// WEBPACK FOOTER //
// ./src/constants/lockedAppsAndTokens.js